const INVALID_REFRESH_TOKEN_MESSAGE = 'Unknown or invalid refresh token';

/**
 * Returns true when Auth0's refresh token rotation has invalidated the stored
 * refresh token (e.g. another tab already rotated it). This is a terminal
 * error — the token cannot be recovered by retrying. The caller should
 * redirect the user to the login page.
 */
export const isInvalidRefreshTokenError = (error: unknown): boolean => {
  if (error instanceof Error) {
    return error.message.includes(INVALID_REFRESH_TOKEN_MESSAGE);
  }
  return false;
};
